import "./App.css";
import firebase from "./firebase.js";
import React from "react";

import Home from "./components/home"; 
import Nav from "./components/top-nav";
import GettingStarted from "./components/getting-started"
import KnowledgeBase from "./components/knowledge-base"
import CurriculumData from "./components/curriculum-data"
import { Route, Switch, Redirect } from "react-router-dom";
 import Footer from "./components/footer"
import Spinner from "./components/spinner"

import Helmet from "react-helmet";

import FAQ from "./components/faqs";
import NotFound from "./components/404"
 
import NetworkTest from "./components/network-test"
import {watchLoggedIn} from "./components/authProvider"

const yaml = require('js-yaml');


let Vimeo = require('vimeo').Vimeo;


let base64 = require("base-64");

var username = "svc-parc-vsts@circadence.com"; // app clientID
var password = "ucrrc6lqncp7tmx3aojeqmh72hsa542oil2jplgw4py6nlwi7u3a"; // app clientSecret

var paths = [];
 
 var pathsmin=[];
var titles=[]

var xhr = new XMLHttpRequest();
var xhr3 = new XMLHttpRequest();


const db = firebase.firestore();

var tempfaqs={};

var temp ={};

var videos = {};
var battlerooms=[];
var missions=[];
var ctf=[];

 
let client = new Vimeo("089bf6c85b628e35642fb1fcc1f29fea71461a52", "FN2n0mZMDxBeCNpmAFTx7Jvbtf3uPJL5MQRufc+Tun0bpAaV7nFoeHzVcKTh6+Qq+9a2dhO+g7WWaAzl7M0iq6jifOeaR8ONAAiam1mOPeZm7dUaMAcj6JywhiR6MXSz", "9453c9e86ddeea467f8bfb54e378a427");
 
 



 async function updateFirestore(collection,scenario,field,content) {

  const scenarioRef = db.collection(collection).doc(scenario);
//console.log(scenarioRef)
 const res = await scenarioRef.update({
   [field]: content
  });


 console.log('Update: ', res);
}




class App extends React.Component {
  constructor(props) {
    super(props);
    window.addEventListener('storage', watchLoggedIn, false);
    this.state = {
      
 
gs:{},
kb:{},
faqs:{},
videos:{}

    };
this.logTrue=this.logTrue.bind(this)

  }



  getVimeoFolders=()=>{
    
     client.request({
        method: 'GET',
        path: '/me/projects?per_page=100'
      }, (error, body, status_code, headers) =>{
        if (error) {
          console.log('error',error);
        }
    
 
this.setState({projects:body.data})
    
   
      
       
      })
    
      
    }
    
  

writeScenarioData(scenario,field,content){


  if(battlerooms.includes(scenario.toLowerCase())){
    //console.log('battleroom',scenario.toLowerCase(),field,content);
 
updateFirestore('battlerooms',scenario.toLowerCase(),field,content)


  }
  if(missions.includes(scenario.toLowerCase())){
   // console.log('mission',scenario,content)
     
updateFirestore('missions',scenario.toLowerCase(),field,content)

  }

  if(ctf.includes(scenario.toLowerCase())){
   // console.log('ctf',scenario,content)
    
updateFirestore('ctf',scenario.toLowerCase(),field,content)

  }

  
}


componentWillUnmount() {
  window.removeEventListener('storage', watchLoggedIn, false);
}

  getFireStore(){
    var current = this;
     
    
      db.collection("battlerooms")
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
             // console.log(doc.id, " => ", doc.data());
            
           temp[doc.id.toLowerCase()]=doc.data();
         battlerooms.push(doc.id.toLowerCase())
  
       
  
  
  
  
  
  
          });
  
  
          db.collection("missions")
          .get()
          .then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
             temp[doc.id.toLowerCase()]=doc.data();
  missions.push(doc.id.toLowerCase())
  
  
      
      
  
  
          
            });
          });
  
  
          db.collection("ctf")
          .get()
          .then(function (querySnapshot) {
            querySnapshot.forEach(function (doc) {
             temp[doc.id.toLowerCase()]=doc.data();
             ctf.push(doc.id.toLowerCase())
             current.setState({scenarios:temp})
  
  
        
            });
          });
  
    
  
  
  
  
  
  
  
        });
  
        db.collection("faqs")
        .get()
        .then( (querySnapshot)=> {
          querySnapshot.forEach(function (doc) {
  
    tempfaqs[doc.id]=doc.data();
   
          });
  
     
          current.setState({
           faqs:tempfaqs
          })
        });
    
  
   
  
      db.collection("resources")
        .get()
        .then( (querySnapshot)=> {
          querySnapshot.forEach(function (doc) {
            var tempGS = current.state.gs;
            var tempKB = current.state.kb;
            if (doc.data().gs==true){ tempGS[doc.id]=doc.data()}
      
            if (doc.data().kb==true){ tempKB[doc.id]=doc.data()}
  
            current.setState({
              gs:tempGS,
              kb:tempKB
            })
  
              
   
          });
        });
  
  
  
  
        
  
        db.collection("masterlist").doc("scenarios")
        .get()
        .then(function(doc) {
          if (doc.exists) {
           
   
              current.setState({
                master:doc.data()
              })
          } else {
              // doc.data() will be undefined in this case
              console.log("No such document!");
          }
      }).catch(function(error) {
          console.log("Error getting document:", error);
      });
  
  
  
            
  
      db.collection("objective-videos")
        .get()
        .then( (querySnapshot)=> {
          querySnapshot.forEach(function (doc) {
            videos[doc.id]=doc.data().url;
            current.setState({videos:videos})
   
          });
  
  
     
        });
   
  }

 
  componentDidMount=()=>{
   
     
  
this.getFireStore();
this.getPaths();
this.getVimeoFolders();

 


  }
 
  getPaths() {
    // create a new XMLHttpRequest
   

    // get a callback when the server responds
    xhr.addEventListener("load", ()=>{
      
        this.cleanPaths(xhr.responseText)
    });

    // open the request with the verb and the url
    //    xhr.open('GET', 'https://dev.azure.com/circadence/Content%20Development/_apis/git/repositories/ares-missions/items?path=/BR1_system_integrator/vem/easy/services_0.yaml&api-version=6.0')
    xhr.open(
      "GET",
      "https://dev.azure.com/circadence/Content%20Development/_apis/git/repositories/ares-missions/items?scopePath=/&recursionLevel=OneLevel&api-version=6.0"
    );
    xhr.setRequestHeader(
      "Authorization",
      "Basic " + base64.encode(username + ":" + password)
    );
    // send the request
    xhr.send();
  }





  cleanPaths(response){
    // update the state of the component with the result here
  
    var temp = JSON.parse(response);
   // console.log("data",temp)
  
    for (var i = 0; i < temp.count; i++) {
      paths.push(temp.value[i].path);
      pathsmin.push(
        temp.value[i].path.substring(1, temp.value[i].path.indexOf("_"))
      );

    }
  
  
  
  
    var missions=  paths.filter(
      (path) => path.charAt(1) == "M"
    ).sort(       (a, b) => parseInt( a.substring(1,a.indexOf("_")).replace(/\D/g,''))    > parseInt( b.substring(1,b.indexOf("_")).replace(/\D/g,''))  ? 1 : -1             );
  
    var battlerooms = paths.filter(
      (path) => path.charAt(1) == "B"  
    ).sort(       (a, b) => parseInt( a.substring(1,a.indexOf("_")).replace(/\D/g,''))    > parseInt( b.substring(1,b.indexOf("_")).replace(/\D/g,''))  ? 1 : -1             );
  
    var missionsmin=  pathsmin.filter(
      (path) => path.charAt(0) == "M"
    ).sort(       (a, b) => parseInt( a.replace(/\D/g,''))    > parseInt( b.replace(/\D/g,''))  ? 1 : -1             );
  
    var battleroomsmin = pathsmin.filter(
      (path) => path.charAt(0) == "B"  
    ).sort(       (a, b) => parseInt( a.replace(/\D/g,''))    > parseInt( b.replace(/\D/g,''))  ? 1 : -1             );
  
  
  
  
    var allpathstemp=battlerooms.concat(missions);
    var pathsmintemp=battleroomsmin.concat(missionsmin);
  
  
  
  
  //console.log(  battlerooms.concat(missions)  );
  
  
  
  
  
    this.setState({
      allpaths:allpathstemp,
      pathsmin:pathsmintemp
      
      
     // paths: access,
  },()=>this.getNames());
  
  
  }


  getNames(){

 
 
  titles=[];
  
    for(var i= 0; i<this.state.allpaths.length;i++){
  
     // console.log("names", i, this.state.allpaths[i])
      this.getName(this.state.allpaths[i], i )
    }
   
  }
  

  
  getName(e, index){

    
    // create a new XMLHttpRequest
    
  
    // get a callback when the server responds
    xhr3.addEventListener("load", () => {
      
   
  titles.splice( index, 0, yaml.load(xhr3.responseText, 'utf8')[0].fields.name);



 // console.log("title",e, YAML.parse(xhr3.responseText)[0].fields.name);
if(  titles.length==this.state.allpaths.length)
  this.setState({titles:titles})
    
    });

 

    
    if (e.charAt( (e.indexOf("_")-1)) === "M") {
     //  console.log(e,e.charAt( (e.indexOf("_")-1) === "M"),"m")

      xhr3.open(
        "GET",
        "https://dev.azure.com/circadence/Content%20Development/_apis/git/repositories/ares-missions/items?path=" +
          e +
          "/game-server/medium/gameserver.yaml"      );
        

      xhr3.setRequestHeader(
        "Authorization",
        "Basic " + base64.encode(username + ":" + password)
      );

      // send the request
      xhr3.send();
      return;
    }


   
    if  (e.charAt( (e.indexOf("_")-1)) === "H") {
       //console.log(e,e.charAt( (e.indexOf("_")-1) === "M"),"h")

      xhr3.open(
        "GET",
        "https://dev.azure.com/circadence/Content%20Development/_apis/git/repositories/ares-missions/items?path=" +
          e +
          "/game-server/hard/gameserver.yaml"      );
        

      xhr3.setRequestHeader(
        "Authorization",
        "Basic " + base64.encode(username + ":" + password)
      );

      // send the request
      xhr3.send();
      return;
    }


    if (
      e.charAt( (e.indexOf("_")-1)) !== "M" &&
      e.charAt( (e.indexOf("_")-1)) !== "H"
    ){
    //  console.log(e,e.charAt( (e.indexOf("_")-1) === "M"),"easy")

      xhr3.open(
        "GET",
        "https://dev.azure.com/circadence/Content%20Development/_apis/git/repositories/ares-missions/items?path=" +
          e +
          "/game-server/easy/gameserver.yaml"      );
        

      xhr3.setRequestHeader(
        "Authorization",
        "Basic " + base64.encode(username + ":" + password)
      );

      // send the request
      xhr3.send();
      return;
    }


 
  }





logTrue(e){
  this.setState({
    loggedIn:true,
    email:e
  })
}
 
  render() {
    return (
   this.state.titles && this.state.master && this.state.scenarios?    <>
      <Nav loggedIn={this.state.loggedIn}/>

      <Helmet>
      <meta name="viewport" content="width=device-width, initial-scale=1"/>
      <link rel="canonical" href="https://projectares.academy" />
 
      </Helmet>


     <Switch>
     
  
 
<Route path="/" component={Home} exact />
       
 
 {/*
<Route
           path="/admin"
           component={() => {
             return <Admin signIn={ <SignIn logTrue={this.logTrue} loggedIn={this.state.loggedIn} email={this.state.email}/>}/>;
           }}
           exact
          />*/}


          

<Route
           path="/network-test"
           component={() => {
             return <NetworkTest/>;
           }}
           exact
         />



       <Route
           path="/getting-started"
           component={() => {
             return <GettingStarted title="Getting Started" resources={this.state.gs} />;
           }}
           exact
         />


 

<Route
           path="/support"
           component={() => {
             return <KnowledgeBase  title="Knowledge Base" resources={this.state.kb} />;
           }}
           exact
         />



         
<Route
           path="/faq"
           component={() => {
             return <FAQ faqs={this.state.faqs} />;
           }}
           exact
         />
 
 <Route
           path="/cyber-curriculum-guide/"
           component={() => {
            window.location.href = 'https://app.projectares.academy/learning-catalog';
             return <CurriculumData master={this.state.master} scenarios={this.state.scenarios} pathsmin={this.state.pathsmin} />;
           }}
           exact
         />
   <Route
           path="/cyber-curriculum-guide/:scenario"
           component={() => {
            window.location.href = 'https://app.projectares.academy/learning-catalog';
             return <CurriculumData write={this.writeScenarioData} titles ={this.state.titles} allpaths ={this.state.allpaths} master={this.state.master} scenarios={this.state.scenarios} data={this.state.data} projects={this.state.projects} pathsmin={this.state.pathsmin} />;
           }}
         />



 
<Route component={NotFound} exact />

        
      </Switch>
      <Footer/>
      </>:<Spinner/>
    );
  }
}

export default App;
 